import { Facebook, Instagram } from "lucide-react";

const TikTokIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    width="20"
    height="20"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.87a8.16 8.16 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.3z" />
  </svg>
);

const SOCIAL_LINKS = [
  { href: "https://www.facebook.com/pastalunaonline?ref=1", label: "Facebook", icon: Facebook, hoverColor: "#1877F2" },
  { href: "https://www.instagram.com/pastaluna_il?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==", label: "Instagram", icon: Instagram, hoverColor: "#E4405F" },
  { href: "https://www.tiktok.com/@pastaluna_il?_r=1&_t=ZS-95OfdegozBa", label: "TikTok", icon: TikTokIcon, hoverColor: "#00F2EA" },
];

interface SocialLinksProps {
  className?: string;
  iconClassName?: string;
}

const SocialLinks = ({ className = "", iconClassName = "w-5 h-5" }: SocialLinksProps) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {SOCIAL_LINKS.map((link) => (
      <a
        key={link.label}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={link.label}
        className="text-muted-foreground transition-colors"
        style={{ ["--hover-color" as string]: link.hoverColor }}
        onMouseEnter={(e) => (e.currentTarget.style.color = link.hoverColor)}
        onMouseLeave={(e) => (e.currentTarget.style.color = "")}
      >
        <link.icon className={iconClassName} />
      </a>
    ))}
  </div>
);

export default SocialLinks;
